'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const designSystem = require('@zapier/design-system');
const React = require('react');
const reactAriaComponents = require('react-aria-components');

const _interopDefault = e => e && e.__esModule ? e : { default: e };

const React__default = /*#__PURE__*/_interopDefault(React);

const clearButton = "_clear-button_lmfsv_1";
const iconWrapper = "_icon-wrapper_lmfsv_26";
const styles = {
	clearButton: clearButton,
	iconWrapper: iconWrapper
};

const TypeaheadRightSlot = ({ iconRight, isTypeaheadDisabled = false, size }) => {
  const state = React.useContext(reactAriaComponents.ComboBoxStateContext);
  const showClearSelectionButton = (state === null || state === void 0 ? void 0 : state.inputValue) && !isTypeaheadDisabled;
  return showClearSelectionButton ? React__default.default.createElement(
    "div",
    { className: styles.iconWrapper, "data-size": size, "data-zds": true },
    React__default.default.createElement(
      reactAriaComponents.Button,
      {
        "aria-label": "Clear selection",
        className: styles.clearButton,
        "data-size": size,
        "data-zds": true,
        onPress: () => state === null || state === void 0 ? void 0 : state.setSelectedKey(null),
        // Don't inherit default RAC Button behavior from RAC ComboBox.
        slot: null
      },
      React__default.default.createElement(designSystem.Icon, { name: "formXCircle", color: "GrayWarm6", size: "24px" })
    )
  ) : iconRight && React__default.default.createElement(
    "div",
    { className: styles.iconWrapper, "data-size": size, "data-zds": true },
    React__default.default.createElement(designSystem.Icon, { name: iconRight, size: "24px" })
  );
};

exports.TypeaheadRightSlot = TypeaheadRightSlot;
//# sourceMappingURL=TypeaheadRightSlot.cjs.js.map
